import { useTranslation } from 'react-i18next'
import { useGenerationFormStore } from '../store'

export function PAGFreeUPanel() {
  const { t } = useTranslation()

  const pagEnabled = useGenerationFormStore((s) => s.pagEnabled)
  const pagScale = useGenerationFormStore((s) => s.pagScale)
  const setPagEnabled = useGenerationFormStore((s) => s.setPagEnabled)
  const setPagScale = useGenerationFormStore((s) => s.setPagScale)

  const freeuEnabled = useGenerationFormStore((s) => s.freeuEnabled)
  const freeuB1 = useGenerationFormStore((s) => s.freeuB1)
  const freeuB2 = useGenerationFormStore((s) => s.freeuB2)
  const freeuS1 = useGenerationFormStore((s) => s.freeuS1)
  const freeuS2 = useGenerationFormStore((s) => s.freeuS2)
  const setFreeuEnabled = useGenerationFormStore((s) => s.setFreeuEnabled)
  const setFreeuB1 = useGenerationFormStore((s) => s.setFreeuB1)
  const setFreeuB2 = useGenerationFormStore((s) => s.setFreeuB2)
  const setFreeuS1 = useGenerationFormStore((s) => s.setFreeuS1)
  const setFreeuS2 = useGenerationFormStore((s) => s.setFreeuS2)

  const isGenerating = useGenerationFormStore((s) => s.isGenerating)

  return (
    <div className="flex flex-col gap-3">
      {/* PAG Section */}
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <label className="text-xs font-medium text-tg-hint">
            {t('generate.pag')}
          </label>
          <button
            type="button"
            onClick={() => { setPagEnabled(!pagEnabled) }}
            disabled={isGenerating}
            className={`relative h-6 w-11 rounded-full transition-colors duration-200 ${
              pagEnabled ? 'bg-tg-button-color' : 'bg-tg-hint/30'
            }`}
          >
            <div
              className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform duration-200 ${
                pagEnabled ? 'translate-x-5' : 'translate-x-0.5'
              }`}
            />
          </button>
        </div>

        {pagEnabled && (
          <div className="flex items-center gap-2">
            <span className="text-xs text-tg-hint w-12">{t('generate.pagScale')}</span>
            <input
              type="range"
              min={0}
              max={10}
              step={0.1}
              value={pagScale}
              onChange={(e) => { setPagScale(Number(e.target.value)) }}
              disabled={isGenerating}
              className="flex-1 accent-tg-button-color"
            />
            <span className="text-xs text-tg-text w-10 text-right tabular-nums">
              {pagScale.toFixed(1)}
            </span>
          </div>
        )}
      </div>

      {/* FreeU Section */}
      <div className="flex flex-col gap-2">
        <div className="flex items-center justify-between">
          <label className="text-xs font-medium text-tg-hint">
            {t('generate.freeu')}
          </label>
          <button
            type="button"
            onClick={() => { setFreeuEnabled(!freeuEnabled) }}
            disabled={isGenerating}
            className={`relative h-6 w-11 rounded-full transition-colors duration-200 ${
              freeuEnabled ? 'bg-tg-button-color' : 'bg-tg-hint/30'
            }`}
          >
            <div
              className={`absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform duration-200 ${
                freeuEnabled ? 'translate-x-5' : 'translate-x-0.5'
              }`}
            />
          </button>
        </div>

        {freeuEnabled && (
          <div className="grid grid-cols-2 gap-2">
            {[
              { label: 'B1', value: freeuB1, setter: setFreeuB1 },
              { label: 'B2', value: freeuB2, setter: setFreeuB2 },
              { label: 'S1', value: freeuS1, setter: setFreeuS1 },
              { label: 'S2', value: freeuS2, setter: setFreeuS2 },
            ].map(({ label, value, setter }) => (
              <div key={label} className="flex items-center gap-2">
                <span className="text-xs text-tg-hint w-6">{label}</span>
                <input
                  type="number"
                  value={value}
                  onChange={(e) => { setter(Number(e.target.value)) }}
                  min={0}
                  max={3}
                  step={0.05}
                  disabled={isGenerating}
                  className="flex-1 rounded border border-tg-hint/20 px-2 py-1 text-xs outline-none input-focus bg-tg-bg text-tg-text"
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
